import { useState } from 'react'
import { postIdea } from '../apiCalls'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'

const NewIdea = (props) => {
    const setNewIdeaToggle = props.mods.setNewIdeaToggle
    const getIdeas = props.mods.getIdeas

    const [ideaForm, setIdeaForm] = useState({
        name: "",
        location: "",
        details: ""
    })

    const handleChange = (e) => {
        setIdeaForm((baseState) => ({
            ...baseState,
            [e.target.name]: e.target.value
        }))
    }

    const handleSubmit = async (e) => {
        try {
            e.preventDefault()
            await postIdea(ideaForm)
            getIdeas()
            e.target.reset()

        } catch(err) {
            console.log(err)
        }
    }

    const handleClose = () => {
        setNewIdeaToggle(false)
    }

    return (
        
        <div className="newDateContainer">
            <i className="bi bi-x-square closeIcon" onClick={handleClose}></i>
            <Container>
                <h2 className="">New Date Idea</h2>
                <Form onSubmit={handleSubmit}>
                <Row>
                    <Form.Group className="sm-2" controlId="ideaName">
                        <Form.Label>Name: </Form.Label>
                        <Form.Control type='text' name="name" onChange={handleChange}></Form.Control>
                    </Form.Group>
                    <Form.Group className="sm-2" controlId="ideaDetails">
                        <Form.Label>Details: </Form.Label>
                        <Form.Control type='text' name="details" onChange={handleChange}></Form.Control>
                    </Form.Group>
                    <Form.Group className="sm-2" controlId="ideaLocation">
                        <Form.Label>Location: </Form.Label>
                        <Form.Control type='text' name="location" onChange={handleChange}></Form.Control>
                    </Form.Group>
                </Row>
                <Row className="inputButtonRow mt-2">
                    <Col className="d-flex justify-content-center">
                        <Button variant="dark" type="submit" className="defaultButton">Submit</Button>
                    </Col>
                </Row>
                </Form>
            </Container>
        </div>
        )
}

export default NewIdea